import React from 'react';

export interface KeyValueItem {
  term: string;
  value: React.ReactNode;
  /** Bold the value - for the one figure the list exists to carry. */
  strong?: boolean;
}

/**
 * Label left, figure right, one row each - the shape of a receipt.
 *
 * Built for the booking dialogs, which are read on phones as often as on
 * desks. A three-column description list gives the label a third of a
 * 320px dialog and wraps "Convenience fee" onto two lines; this gives the
 * label whatever it needs and right-aligns the figures so the decimals line
 * up top to bottom.
 */
export function KeyValueList({
  items,
  title,
}: {
  items: ReadonlyArray<KeyValueItem>;
  title?: string;
}): React.JSX.Element {
  return (
    <div className="rounded-lg border border-zinc-200 p-3">
      {title && (
        <div className="mb-2 text-[11px] font-medium tracking-wide text-zinc-500 uppercase">
          {title}
        </div>
      )}
      <dl className="grid grid-cols-[1fr_auto] gap-x-3 gap-y-1.5 text-sm">
        {items.map((it) => (
          <React.Fragment key={it.term}>
            <dt className="min-w-0 text-zinc-600">{it.term}</dt>
            <dd
              className={`m-0 max-w-[60%] justify-self-end text-right wrap-break-word tabular-nums ${
                it.strong ? 'font-semibold text-zinc-900' : 'text-zinc-900'
              }`}
            >
              {it.value}
            </dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
}
